module.exports = __webpack_public_path__ + "images/0cf2a638b5c88b306bfd8ca912ef54f5.svg";